import Utils from '@/core/utils'
import i18n from '@/i18n'

const getParamsByType = (params, type) => {
  return params.filter((param) => param[type])
}
const state = () => ({
  detail: {},
  id: null,
  currentType: {},
  familyTypes: [],
  familyDefinition: [], // G使用
  familyValue: [], // G使用
  properties: [], // 最终展示
  viewToken: '',
  geometryData: [], // 显示尺寸标注
  placeholders: [], // 外嵌图例
  inputParameters: [], // 3D展示的驱动参数
})

const mutations = {
  SET_DETAIL(state, detail) {
    state.detail = detail
  },

  // 更新单个构件信息
  UPDATE_DETAIL(state, updateObj) {
    state.detail = { ...state.detail, ...updateObj }
  },

  SET_ID(state, id) {
    state.id = id
  },

  SET_CURRENT_TYPE(state, value) {
    state.currentType = value
  },

  SET_FAMILY_DEFINITION(state, def) {
    state.familyDefinition = def
  },

  SET_FAMILY_VALUE(state, value) {
    state.familyValue = value
  },

  SET_PROPERTIES(state, properties) {
    if (state.detail && state.detail.softwareCode !== 'revit') {
      const formatParameters = state.familyDefinition.reduce((acc, def) => {
        const v = state.familyValue && state.familyValue.parameterValues.find((fv) => {
          if (!def.isStandard) {
            return def.name === fv.name && !fv.parameterCode
          }
          return def.name === fv.name
        })
        if (!def.isUserVisible || def.parameterDisplayType === 'NoDisplay' || def.parameterType === 'ElementId') {
          return acc
        }
        const parameter = {}
        parameter.name = def.name
        let value
        if (v) {
          value = v.displayValue || v.value
          if (def.parameterDisplayType === 'Angle' && !v.displayValue) {
            value = Utils.rad2deg(value)
          }
          if (def.valueType === 'Number' || def.valueType === 'Int') {
            value = Utils.formatDecimal(value, 2)
            const unit = def.displayUnit || v.displayUnit || def.unit
            parameter.value = unit && unit !== 'ul' ? value + unit : value
          } else if (def.valueType === 'Enum') {
            parameter.value = def.values ? def.values[value] : ''
          } else if (def.valueType === 'Logic') {
            parameter.value = value && value.toLowerCase() === 'true' ? i18n.t('common.yes') : i18n.t('common.no')
          } else {
            parameter.value = value
          }
        } else {
          parameter.value = ''
        }
        if (def.isGeometry) {
          parameter.isGeometry = true
        } else if (!def.groupName && !def.isGeometry) {
          parameter.isCustom = true
        } else {
          parameter.isStandard = true
          parameter.groupName = def.groupName
        }
        acc.push(parameter)
        return acc
      }, [])
      const standardData = getParamsByType(formatParameters, 'isStandard')
      const defObj = {}
      standardData.forEach((standard) => {
        defObj[standard.groupName] ? defObj[standard.groupName].push(standard) : defObj[standard.groupName] = [standard]
      })
      const keysArr = Object.keys(defObj)
      const standardGroups = keysArr.reduce((acc, def) => {
        acc.push({
          name: def,
          parameterValues: defObj[def]
        })
        return acc
      }, [])
      const geometryData = getParamsByType(formatParameters, 'isGeometry')
      state.geometryData = geometryData
      state.properties = [
        {
          name: i18n.t('component.geometryProperties'),
          parameterValues: geometryData
        },
        ...standardGroups,
        {
          name: i18n.t('component.customProperties'),
          parameterValues: getParamsByType(formatParameters, 'isCustom')
        }
      ]
    } else {
      state.properties = properties
    }
  },

  SET_VIEW_TOKEN(state, viewToken) {
    state.viewToken = viewToken
  },
  SET_FAMILY_TYPES(state) {
    const familyTypes = state.detail.familyTypeNames || state.detail.familyTypes
    if (familyTypes && familyTypes.length) {
      if (state.detail && state.detail.softwareCode !== 'revit') {
        state.familyTypes = familyTypes.map(
          (item) => {
            return {
              id: item.uuid,
              ...item
            }
          }
        )
      } else {
        state.familyTypes = familyTypes.map(
          (item, index) => {
            return {
              id: index,
              name: item || i18n.t('component.default')
            }
          })
      }
    } else {
      state.familyTypes = []
    }
  },
  SET_PLACEHOLDERS(state, data) {
    state.placeholders = data
  },
  SET_INPUT_PARAMETERS(state) {
    if (state.detail && state.detail.softwareCode !== 'revit') {
      const parameters = state.familyDefinition.reduce((input, def) => {
        if (def.guid && (def.isDriveParameter || def.isOutputParameter || def.isGeometry)) {
          const parameter = state.familyValue && state.familyValue.parameterValues.find((fv) => {
            if (!def.isStandard) {
              return def.name === fv.name && !fv.parameterCode
            }
            return def.name === fv.name
          })
          if (parameter) {
            input.push({ guid: def.guid, value: parameter.value })
          }
        }
        return input
      }, [])
      state.inputParameters = parameters
    }
  }
}

const getters = {
  DETAIL: (state) => state.detail,
  FAMILYTYPES: (state) => state.familyTypes,
  CURRENTTYPE: (state) => state.currentType,
  PROPERTIES: (state) => state.properties,
  INPUT_PARAMETERS: (state) => state.inputParameters,
  THUMBNAILS: (state) => {
    let thumbnails = []
    if (state.detail.thumbnailSizes && state.detail.thumbnailSizes.length > 0) {
      const sizes = [...state.detail.thumbnailSizes]
      thumbnails = sizes.sort((t1, t2) =>
        Number(t2.size) - Number(t1.size))[0].thumbnails || []
    }
    thumbnails = thumbnails.map((t) => `${process.env.VUE_APP_STATIC_HOST}/${t}`)
    return thumbnails
  },
  VIEW_TOKEN: (state) => state.viewToken,
  GEOMETRY_DATA: (state) => state.geometryData,
  PLACEHOLDERS: (state) => {
    if (state.detail.placeholders && state.detail.placeholders.length) {
      return state.placeholders
    } else {
      const bps = []
      if (state.detail.builtinPlaceholders && state.detail.builtinPlaceholders.length) {
        state.detail.builtinPlaceholders.forEach((item) => {
          const thumbObj = item.thumbnails ? item.thumbnails.find((t) => t.size === '256') : {}
          const obj = {
            placeholderType: item.placeholderType,
            thumbnail: thumbObj.thumbnails[0]
          }
          bps.push(obj)
        })
      }
      return bps
    }
  },
  BUILT_IN_PLACEHOLDERS: (state) => {
    const bps = []
    if (state.detail.builtinPlaceholders && state.detail.builtinPlaceholders.length) {
      state.detail.builtinPlaceholders.forEach((item) => {
        const thumbObj = item.thumbnails ? item.thumbnails.find((t) => t.size === '256') : {}
        const obj = {
          placeholderType: item.placeholderType,
          thumbnail: thumbObj.thumbnails[0]
        }
        bps.push(obj)
      })
    }
    return bps
  },
}

const actions = {
  async LOAD_DETAIL({ commit, state, rootState }, { softwareCode, softwareVersion, familyTypeName }) {
    try {
      let detail
      if (['bimmake', 'sketchup'].includes(softwareCode.toLowerCase())) {
        detail = await this.$api.generalComponent.detail(state.id)
      } else if (rootState.platform === 'g' || rootState.platform === 'cs') {
        detail = await this.$api.gcsComponent.detail(softwareCode, state.id, softwareVersion, { family_type_name: familyTypeName })
      } else {
        detail = await this.$api.revitComponent.detail(state.id)
      }
      commit('SET_DETAIL', detail || {})
      commit('SET_FAMILY_TYPES')
      commit('SET_CURRENT_TYPE', state.familyTypes[0] || {})
      commit('SET_FAMILY_DEFINITION', detail.parameterDefinitions || [])
    } catch (error) {
      commit('SET_DETAIL', {})
      commit('SET_CURRENT_TYPE', {})
      commit('SET_FAMILY_DEFINITION', [])

      console.log(error)
      // 外界接收错误，并决定处理方法
      throw new Error(error)
    }
  },

  async LOAD_PROPERTIES({ commit, getters, state, rootState }, currentType) {
    try {
      const familyType = currentType || state.currentType
      let properties
      if (familyType && (familyType.id || familyType.id === 0)) {
        if (rootState.platform === 'g' || rootState.platform === 'cs') {
          properties = await this.$api.gcsComponent.properties(state.detail.softwareCode, state.id, familyType.uuid, state.detail.softwareVersion)
        } else {
          const familyTypeName = familyType.name === i18n.t('component.default') ? '' : familyType.name
          properties = await this.$api.revitComponent.properties(state.id, familyTypeName)
        }
      }
      if (rootState.platform === 'g' || rootState.platform === 'cs') {
        commit('SET_FAMILY_VALUE', properties)
        commit('SET_PROPERTIES')
        commit('SET_INPUT_PARAMETERS')
      } else {
        commit('SET_PROPERTIES', properties)
      }
    } catch (error) {
      console.error(error)
      commit('SET_PROPERTIES', [])
    }
  },

  async LOAD_VIEW_TOKEN({ commit, state }) {
    try {
      const viewToken = await this.$api.revitComponent.viewToken(state.id)
      commit('SET_VIEW_TOKEN', viewToken)
    } catch (error) {
      console.error(error)
      commit('SET_VIEW_TOKEN', '')
    }
  },

  async LOAD_PLACEHOLDERS({ commit, state }) {
    try {
      const { softwareCode, softwareVersion } = state.detail
      const placeholders = await this.$api.gcsComponent.placeholders(softwareCode, state.id, softwareVersion)
      commit('SET_PLACEHOLDERS', placeholders)
    } catch (error) {
      console.error(error)
      commit('SET_PLACEHOLDERS', [])
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
